/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Topbar } from './components';

const useStyles = makeStyles(() => ({
    root: {
        paddingTop: 64,
        height: '100%',
    },
    content: {
        height: '100%',
    },
}));

const Minimal = (props) => {
    const { children } = props;

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Topbar />
            <main className={classes.content}>{children}</main>
        </div>
    );
};

Minimal.propTypes = {
    // eslint-disable-next-line react/require-default-props
    children: PropTypes.node,
    // eslint-disable-next-line react/no-unused-prop-types
    // eslint-disable-next-line react/require-default-props
    // eslint-disable-next-line react/no-unused-prop-types
    className: PropTypes.string,
};

export default Minimal;
